import { render } from "./CustomersSection.vue?vue&type=template&id=d11441d8&scoped=true"
import script from "./CustomersSection.vue?vue&type=script&lang=js"
export * from "./CustomersSection.vue?vue&type=script&lang=js"

import "./CustomersSection.vue?vue&type=style&index=0&id=d11441d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d11441d8"]])

export default __exports__